
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { NotificationService } from 'src/app/_services/notification.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { ProductService } from '../../_ecomservices/product.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CategoryCreateComponent } from '../category-create/category-create.component';
import { BrandCreateComponent } from '../brand-create/brand-create.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { SelectionModel } from '@angular/cdk/collections';
import { Location } from '@angular/common';
import { DialogService } from 'src/app/_services/dialog.service';
// import { ColorCreateComponent } from '../color-create/color-create.component';
import { CreateColorComponent } from '../product-colors/product-colors.component';
import { ProductSizeDialogComponent } from '../product-size/product-size.component';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.css']
})
export class ProductEditComponent implements OnInit {

  checked = false;
  disabled = false;

  siteUrl = environment.siteUrl;

  product_id: any = 0;
  product_categories: any = [];
  product_image_list: any = [];

  primary_img: File = null;
  primaryImagePreview: string | ArrayBuffer | null = null;
  secondary_img: File = null;
  secondaryImagePreview: string | ArrayBuffer | null = null;

  image_1: File = null;
  image_1Preview: string | ArrayBuffer | null = null;
  image_2: File = null;
  image_2Preview: string | ArrayBuffer | null = null;
  image_3: File = null;
  image_3Preview: string | ArrayBuffer | null = null;
  image_4: File = null;
  image_4Preview: string | ArrayBuffer | null = null;
  image_5: File = null;
  image_5Preview: string | ArrayBuffer | null = null;
  image_6: File = null;
  image_6Preview: string | ArrayBuffer | null = null;

  categoryDisplayedColumns: string[] = ['select', 'CategoryName', 'ParentCategory'];
  categoryDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) categoryPaginator: MatPaginator;
  categorySearchKey: string;
  categorySelection = new SelectionModel<any>(true, []);

  brandDisplayedColumns: string[] = ['select', 'BrandName'];
  brandDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) brandPaginator: MatPaginator;
  brandSearchKey: string;
  selectedBrand: any;

  colorDisplayedColumns: string[] = ['select', 'ColorName', 'ColorCode'];
  colorDataSource: MatTableDataSource<any>;
  colorSelection = new SelectionModel<any>(true, []);

  chartDataSource: MatTableDataSource<any>;
  chartSelection = new SelectionModel<any>(true, []);

  sizeDisplayedColumns: string[] = ['select', 'SizeName', 'SizeCode'];
  sizeDataSource: MatTableDataSource<any>;
  sizeSelection = new SelectionModel<any>(true, []);

  product_edit_form = new FormGroup({
    id: new FormControl(null),
    prod_type: new FormControl(),
    prod_name: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    slug: new FormControl(''),
    sku: new FormControl(''),
    prod_desc: new FormControl('', [Validators.required]),
    pack_qty: new FormControl(''),
    pack_price: new FormControl(''),
    regular_price: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    sale_price: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    stock_qty: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    min_order_qty: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    primary_img: new FormControl(null),
    secondary_img: new FormControl(null),
    is_sale: new FormControl(0, [Validators.required]),
    is_returnable: new FormControl(0, [Validators.required]),
    is_cod: new FormControl(0, [Validators.required]),
    product_rating: new FormControl(''),
    color_id: new FormControl(''),
    brand_id: new FormControl(),
    status: new FormControl('', [Validators.required]),

    size_chart_id: new FormControl(''),
    product_tag: new FormControl(''),
    product_quality: new FormControl(''),

  });

  seo_metadata = null;

  

  product_variations: any = [];
  product_variation_form = new FormGroup({
    id: new FormControl(null),
    product_id: new FormControl('', [Validators.required]),
    variations_name: new FormControl(''),
    slug: new FormControl(''),
    sku: new FormControl(''),
    size_id: new FormControl(''),
    color_id: new FormControl(''),
    regular_price: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    sale_price: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    stock_qty: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    // min_order_qty : new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    // primary_img : new FormControl(null),
    // secondary_img : new FormControl(null),
    // category_id : new FormControl(),
    // is_sale : new FormControl(0, [Validators.required]),
    // brand_id : new FormControl(),
    // status : new FormControl('', [Validators.required]),
  });

  key_highlights_data: any = [];

  product_review_data: any = [];

  constructor(
    private dialogService: DialogService,
    private route: ActivatedRoute,
    public productService: ProductService,
    private dialog: MatDialog,
    private loading: LoadingService,
    private notificationService: NotificationService,
    private http: HttpClient,
    private _location: Location,
    private router: Router) {
    this.loading.spin$.next(true);
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.product_id = params.get('id');
      this.onloadProductDetails();
      // this.onloadKeyHighlightsDetails();
    });

    this.get_size_charts();


  }

  onloadProductDetails() {
    this.productService.get_product_id(this.product_id).subscribe(data => {
      console.log(data);
      if (data['status']) {
        this.seo_metadata = data['product_data']['seo_metadata'];
        this.populateForm(data['product_data']);
        this.product_variations = data['product_data']['product_variations'];
        this.categoryDataSource = new MatTableDataSource<any>(data['category_list']);
        this.brandDataSource = new MatTableDataSource<any>(data['brand_list']);
        this.product_categories = data['product_data']['product_categories'];
        this.product_image_list = data['product_data']['product_image_list'];
        this.key_highlights_data = data['product_data']['product_key_highlights'];
        this.get_active_category();
        this.get_active_brand();
        this.get_active_colors();
        this.get_active_sizes();
        this.onloadProductReview();
        this.primaryImagePreview = data['product_data']['primary_img'];
        this.secondaryImagePreview = data['product_data']['secondary_img'];
        const imageNumbers = [1, 2, 3, 4, 5, 6];

        imageNumbers.forEach(imageNo => {
          const foundImage = this.product_image_list.find(x => x.image_no === imageNo);
          if (foundImage) {
            this[`image_${imageNo}Preview`] = foundImage ? foundImage.prod_img_url : null;
          }
        });
        this.loading.spin$.next(false);
      }
      else {
        this._location.back();
        this.notificationService.error(data['message']);
      }
    });
  }

  populateForm(rowData: any) {
    rowData.status = String(rowData.status);
    this.product_edit_form.setValue(_.omit(rowData, 'product_variations', 'product_categories', 'product_image_list', 'product_key_highlights', 'product_review', 'seo_metadata', 'created_at', 'updated_at', 'deleted_at'));
  }

  onUpdateProductFormSubmit(formData: any) {
    // Product Color Validation
    let isColorValidate = true;
    this.product_variations.forEach(element => {
      if (element.color_id > 0) {
        const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
          '((([a-zA-Z0-9-]+)\\.)+[a-zA-Z]{2,})' + // domain name and extension
          '(\\:\\d+)?(\\/[-a-zA-Z0-9%_.~+]*)*' + // port and path
          '(\\?[;&a-zA-Z0-9%_.~+=-]*)?' + // query string
          '(\\#[-a-zA-Z0-9_]*)?$', 'i'); // fragment locator
        if (!pattern.test(element.color_page_link)) {
          isColorValidate = false;
        }
      }
    });

    if (!isColorValidate) {
      this.notificationService.warn('Please fill color page link');
    }
    else if (!this.product_edit_form.value.brand_id) {
      this.notificationService.warn('Please select product brand');
    }
    else if (this.product_edit_form.valid) {
       this.loading.spin$.next(true);
      this.productService.update_product(formData, this.primary_img, this.secondary_img, this.image_1,
        this.image_2, this.image_3, this.image_4, this.image_5, this.image_6, this.categorySelection.selected, this.product_variations).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['error_message']);
            this.loading.spin$.next(false);
          }
        });
    }
  }

  onUpdateProductVariationFormSubmit(formData: any) {
  }

  onRemoveVariation(variation: any) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.productService.delete_product_variation(variation.id).subscribe(data => {
            if (data['status']) {
              let varIndex = this.product_variations.findIndex(x => x.id == variation.id);
              console.log(varIndex);
              if (varIndex !== -1) {
                // remove variation from product variation list
                this.product_variations.splice(varIndex, 1);

                // Deselect size checkbox
                this.sizeDataSource.data.forEach(row => {
                  if (row.id == variation.size_id) {
                    this.sizeSelection.deselect(row);
                  }
                });

                // Deselect color checkbox
                this.colorDataSource.data.forEach(row => {
                  if (row.id == variation.color_id) {
                    this.colorSelection.deselect(row);
                  }
                });

              }
              this.notificationService.success(data['message']);
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error('Product data could not be updated, Try Again!');
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

  get_active_brand() {
    var result = this.productService.get_active_brand().subscribe(data => {
      if (data['status']) {
        this.brandDataSource = new MatTableDataSource<any>(data['brand_list']);
        let product_brand = this.product_edit_form.value.brand_id;
        const matchedBrand = this.brandDataSource.data.find(row => row.id === product_brand);
        if (matchedBrand) {
          this.selectedBrand = matchedBrand;
        }
      }
    });
  }

  onBrandSelectionChange(row: any) {
    this.product_edit_form.controls['brand_id'].setValue(this.selectedBrand.id);
  }

  brandApplyFilter() {
    this.brandDataSource.filter = this.brandSearchKey.trim().toLocaleLowerCase();
  }

  onBrandSearchClear() {
    this.brandSearchKey = "";
    this.brandApplyFilter();
  }

  get_active_category() {
    var result = this.productService.get_active_category().subscribe(data => {
      if (data['status']) {
        this.categoryDataSource = new MatTableDataSource<any>(data['category_list']);
        this.categoryDataSource.data.forEach(row => {
          const cat_check = this.product_categories.find(x => x.id === row.id);
          if (cat_check) {
            this.categorySelection.select(row)
          }
        });
      }
    });
  }

  categoryApplyFilter() {
    this.categoryDataSource.filter = this.categorySearchKey.trim().toLocaleLowerCase();
  }

  onCategorySearchClear() {
    this.categorySearchKey = "";
    this.categoryApplyFilter();
  }

  isAllCategorySelected() {
    const numSelected = this.categorySelection.selected.length;
    const numRows = this.categoryDataSource.data.length;
    return numSelected === numRows;
  }

  categoryMasterToggle() {
    this.isAllCategorySelected() ?
      this.categorySelection.clear() :
      this.categoryDataSource.data.forEach(row => this.categorySelection.select(row));
  }

  get_active_colors() {
    var result = this.productService.get_active_colors().subscribe(data => {
      if (data['status']) {
        this.colorDataSource = new MatTableDataSource<any>(data['colors']);
        //console.log(data);
        this.colorDataSource.data.forEach(row => {
          const cat_check = this.product_variations.find(x => x.color_id === row.id);
          if (cat_check) {
            this.colorSelection.select(row)
          }
        });
      }
    });
  }

  get_size_charts() {
    var result = this.productService.get_size_charts().subscribe(data => {
      if (data['status']) {
        this.chartDataSource = new MatTableDataSource<any>(data['data_list']);
        //console.log(data);
        this.chartDataSource.data.forEach(row => {
          const cat_check = this.product_variations.find(x => x.chart_id === row.id);
          if (cat_check) {
            this.chartSelection.select(row)
          }
        });
      }
    });
  }

  isAllColorSelected() {
    const numSelected = this.colorSelection.selected.length;
    const numRows = this.colorDataSource.data.length;
    return numSelected === numRows;
  }

  colorMasterToggle() {
    this.isAllColorSelected() ?
      this.colorSelection.clear() :
      this.colorDataSource.data.forEach(row => this.colorSelection.select(row));
    this.onAddProductColor();
  }

  onChangeColor($event, row) {
    $event ? this.colorSelection.toggle(row) : null;
    $event.checked ? this.onAddProductColor() : null;
    console.log(this.product_variations);
  }

  onAddProductColor() {
    let colorSelection = this.colorSelection.selected;
    colorSelection.forEach(row => {
      const cat_check = this.product_variations.find(x => x.color_id === row.id);
      if (cat_check) {
        // this.sizeSelection.select(row)
      }
      else {
        const color_variation = {
          "product_id": this.product_edit_form.value.id,
          // "variations_name": "SAMSUNG Galaxy Z Fold5-Red-M",
          // "slug": "samsung-galaxy-z-fold5-red-m",
          // "sku": null,
          "size": null,
          "size_id": null,
          "color_id": row.id,
          "color": row.color_code,
          'color_page_link': null,
          "regular_price": null,
          "sale_price": null,
          "stock_qty": 0,
          "pack_qty": 0,
          "pack_price": 0,
        }
        console.log(color_variation);
        this.productService.add_product_variation_color(color_variation).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.product_variations.push(data['new_variation']);
          }
        })
      }
    });
  }

  get_active_sizes() {
    var result = this.productService.get_active_sizes().subscribe(data => {
      if (data['status']) {
        this.sizeDataSource = new MatTableDataSource<any>(data['sizes']);
        this.sizeDataSource.data.forEach(row => {
          const cat_check = this.product_variations.find(x => x.size_id === row.id);
          if (cat_check) {
            this.sizeSelection.select(row)
          }
        });
      }
    });
  }

  isAllSizeSelected() {
    const numSelected = this.sizeSelection.selected.length;
    const numRows = this.sizeDataSource.data.length;
    return numSelected === numRows;
  }

  sizeMasterToggle() {
    this.isAllSizeSelected() ?
      this.sizeSelection.clear() :
      this.sizeDataSource.data.forEach(row => this.sizeSelection.select(row));
    this.onAddProductSize();
  }

  onChangeSize($event, row) {
    $event ? this.sizeSelection.toggle(row) : null;
    $event.checked ? this.onAddProductSize() : null;
    console.log(this.product_variations);
  }

  onAddProductSize() {
    let sizeSelection = this.sizeSelection.selected;
    sizeSelection.forEach(row => {
      const cat_check = this.product_variations.find(x => x.size_id === row.id);
      if (cat_check) {
        // this.sizeSelection.select(row)
      }
      else {
        const size_variation = {
          "product_id": this.product_edit_form.value.id,
          // "variations_name": "SAMSUNG Galaxy Z Fold5-Red-M",
          // "slug": "samsung-galaxy-z-fold5-red-m",
          // "sku": null,
          "size": row.size_code,
          "size_id": row.id,
          "color": null,
          "color_id": null,
          'color_page_link': null,
          "regular_price": this.product_edit_form.value.regular_price,
          "sale_price": this.product_edit_form.value.sale_price,
          "stock_qty": 0,
        }
        this.productService.add_product_variation_size(size_variation).subscribe(data => {
          if (data['status']) {
            this.product_variations.push(data['new_product_size']);
          }
        })
      }
    });
  }

  onCreateCategory() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { mobile: '' }
    this.dialog.open(CategoryCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_active_category();
    });
  }

  onCreateBrand() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { mobile: '' }
    this.dialog.open(BrandCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_active_brand();
    });
  }

  onCreateColor() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "35%";
    matDialogConfig.position = { top: '10px' }
    this.dialog.open(CreateColorComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_active_colors();
    });
  }

  onCreateSize() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { mobile: '' }
    this.dialog.open(ProductSizeDialogComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.get_active_sizes();
    });
  }

  /* Product Images */

  onSelectPrimaryImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.primary_img = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.primaryImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectSecondaryImageFile(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.secondary_img = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.secondaryImagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectImage_1File(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.image_1 = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.image_1Preview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectImage_2File(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.image_2 = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.image_2Preview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectImage_3File(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.image_3 = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.image_3Preview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectImage_4File(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.image_4 = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.image_4Preview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectImage_5File(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.image_5 = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.image_5Preview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSelectImage_6File(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.image_6 = file;
      // Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.image_6Preview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage(imgno) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this image?')
      .afterClosed().subscribe(res => {
        if (res) {
          // this.loading.spin$.next(true);
          this.productService.delete_product_image(this.product_id, imgno).subscribe(data => {
            console.log(data);
            if (data['status']) {
              this.product_image_list = this.product_image_list.filter(x => x.image_no !== imgno);
              this[`image_${imgno}Preview`] = null;
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

  /* Product Key Highlights */
  onloadKeyHighlightsDetails() {
    var result = this.productService.get_product_key_highlight(this.product_id).subscribe(data => {
      this.key_highlights_data = data['dataList'];
    });
  }

  onCreateKeyHighlights() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { product_id: this.product_id }
    this.dialog.open(KeyHighlightsCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onloadKeyHighlightsDetails();
    });
  }

  onEditProductKeyHighlight(rowData: any) {
    this.productService.populateKeyHighlightsForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { product_id: this.product_id }
    this.dialog.open(KeyHighlightsCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onloadKeyHighlightsDetails();
    });
  }

  onDeleteProductKeyHighlight(keyhighlightId) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.productService.delete_key_highlight(keyhighlightId).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.onloadKeyHighlightsDetails();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error(data['message']);
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }

  /* Product Review */
  onloadProductReview() {
    var result = this.productService.get_product_review(this.product_id).subscribe(data => {
      this.product_review_data = data['product_review'];
    });
  }

  toggleReviewStatusChange(event: any, reviewId: any) {
    let checked = event.checked;
    let status = checked ? 1 : 0;
    this.productService.update_review_status(reviewId, status).subscribe(data => {
      console.log(data);
    });
  }

  onCreateProductReview() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { product_id: this.product_id }
    this.dialog.open(ProductReviewCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onloadProductReview();
    });
  }

  onEditProductReview(rowData: any) {
    this.productService.populateProductReviewForm(rowData);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "40%";
    matDialogConfig.position = { top: '10px' };
    matDialogConfig.data = { product_id: this.product_id }
    this.dialog.open(ProductReviewCreateComponent, matDialogConfig).afterClosed().subscribe(res => {
      this.onloadProductReview();
    });
  }

  onDeleteProductReview(productreviewId) {
    this.dialogService.openConfirmDialog('Are you sure want to delete this Review?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.loading.spin$.next(true);
          this.productService.delete_product_review(productreviewId).subscribe(data => {
            if (data['status']) {
              this.notificationService.success(data['message']);
              this.onloadProductReview();
              this.loading.spin$.next(false);
            }
            else {
              this.notificationService.error(data['message']);
              this.loading.spin$.next(false);
            }
          });
        }
      });
  }



}












/* Create Key Highlights */
@Component({
  selector: 'add-key_highlights-dialog',
  templateUrl: 'add-key_highlights-dialog.html',
})
export class KeyHighlightsCreateComponent {

  product_id: any = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ProductEditComponent>,
    public productService: ProductService,
    private loading: LoadingService,
    private notificationService: NotificationService,
  ) {
    this.product_id = data.product_id;
  }

  onKeyHighlightsFormSubmit(formData: any) {
    if (this.productService.key_highlights_form.valid) {
      this.loading.spin$.next(true);
      if (!this.productService.key_highlights_form.controls['id'].value) {
        // Insert Data
        this.productService.insert_key_highlights(formData, this.product_id).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        this.productService.update_key_highlights(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }


  onClose() {
    this.productService.key_highlights_form.reset();
    this.dialogRef.close();
  }


}




/* Create Product Review */
@Component({
  selector: 'add-product-review-dialog',
  templateUrl: 'add-product-review-dialog.html',
})
export class ProductReviewCreateComponent {

  product_id: any = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ProductEditComponent>,
    public productService: ProductService,
    private loading: LoadingService,
    private notificationService: NotificationService,
  ) {
    this.product_id = data.product_id;
  }

  onProductReviewFormSubmit(formData: any) {
    if (this.productService.product_review_form.valid) {
      this.loading.spin$.next(true);
      if (!this.productService.product_review_form.controls['id'].value) {
        // Insert Data
        this.productService.insert_product_review(formData, this.product_id).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        this.productService.update_product_review(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
  }


  onClose() {
    // console.log('Close');
    this.productService.product_review_form.reset();
    this.dialogRef.close();
  }


}
